import React, { useState, useEffect } from 'react'
import { useForm, useFormState } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import EmailTemplate from '../../components/Modal/EmailTemplate'
import { eventEmail } from '../slice/createEventSlice'
import http, { imageURL, URL_S3 } from '../../../../config/BaseUrl'
import { LoadingSpinner } from '../../../../components/Loader/Loader'

const Email = () => {
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [emailTemplate, setTemplate] = useState(null)
    const [emailTemplateErr, setTemplateErr] = useState(false)
    const [emailTemplateType, setEmailTemplateType] = useState(null)
    const [emailTemplateContents, setEmailTemplateContents] = useState(null)
    const [email_my_template_id, setEmailMyTemplateId] = useState(null)

    const history = useHistory()
    const dispatch = useDispatch()
    // const eventId = history.location.state
    const { event_option, email, eventId } = useSelector(state => state.createEvent)
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: {
            from_name: email.from_name,
            reply_to: email.reply_to,
            email_subject: email.email_subject,
            body: email.body,
            attach_file: email.attach_file,
            link_image: email.link_image,
            email_suffixes: email.email_suffixes
        }

    });

    useEffect(() => {
        if (email) {
            setTemplate(email.email_template)
        }
    }, [email])

    useEffect(()=>{
        if (typeof history.location.state == "object" && "editedData" in history.location.state) {
            const theData = history.location.state.editedData
            setTemplate(theData.template)
            setEmailTemplateType(theData.saveAs)
            setEmailTemplateContents(theData.content)

            if (theData.saveAs == 'my_template') {
                setEmailMyTemplateId(theData.email_my_template_id)
            }
            else{
                setEmailMyTemplateId(null)
            }

        }
    }, [history])


    const handelEmail = async (data) => {

        if (emailTemplate) {
            dispatch(eventEmail({ ...data, email_template: emailTemplate }))
            setLoading(true)
            http.post("email", { ...data, email_template: emailTemplate, eventId,  template_type: emailTemplateType, email_my_template_id, contents: emailTemplateContents }).then(res => {
                setLoading(false)
                if (res.data.event_email.draft_status === 'draft') {
                         if (event_option.text_messaging    === true) { history.push('/event/sms', eventId) }
                    else if (event_option.digital_props     === true) { history.push('/event/digital-prop', eventId) }
                    else if (event_option.water_mark        === true) { history.push('/event/custom-branding', eventId) }
                    else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                    else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                    else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                    else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                    else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                    else { history.push('/event/summary', eventId) }
                }
            }).catch(err => err.response.data.message)

        }
        else {
            setTemplateErr(true)
        }

    }

    const setEmailTemplateByProps = (data) => {
        
        if ('contents' in data) {
            setTemplate({id: data.id, image: data.image})
            setEmailTemplateContents(data.contents)
            setEmailTemplateType('my_template')
            setEmailMyTemplateId(data.email_my_template_id)
        }
        else{
            setTemplate(data)
        }
        setTemplateErr(false)
    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            if (emailTemplate) {
                dispatch(eventEmail({ ...data, email_template: emailTemplate }))
                setDraftLoading(true)
                http.post("email", { ...data, email_template: emailTemplate, eventId, template_type: emailTemplateType, email_my_template_id, contents: emailTemplateContents }).then(res => {
                    setDraftLoading(false)
                }).catch(err => {
                    setDraftLoading(false)
                })
            }
            else {
                setTemplateErr(true)
            }

        })()
    }

    const BackToPreviousPage = (e) => {
        e.preventDefault()
               if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
          else if (event_option.gif            === true) { history.push('/event/gif') }
          else if (event_option.social_media   === true) { history.push('/event/social') }
          else { history.push('/event/options') }
    }

    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Email Settings</p>
                                            <p className="mb-0 text-secondary">Setup email sharing for your event</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(handelEmail)} >
                    <div className="row justify-content-center">
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-body" style={{ minHeight: '330px' }}>
                                    <div className="row">
                                        <div className="col-sm-6 d-flex align-items-center flex-column justify-content-center">

                                            <div className="place-holder-section">
                                                {
                                                    !emailTemplate ?
                                                        <div className="default-section">
                                                            <h4>Choose Email Template.</h4>
                                                        </div>
                                                        :
                                                        <div className="default-section">
                                                            <img src={`${URL_S3}image/email_template/${emailTemplate.image}`} className="img-fluid" alt="email-template" />
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <button type="button" className="btn btn-primary btn-block" data-toggle="modal" data-target="#email-template">Template Library</button>

                                            <p className={`pt-2 text-danger font-weight-bold fade ${emailTemplateErr ? 'show' : 'hide'}`}>Choose any template</p>
                                            <EmailTemplate setData={setEmailTemplateByProps} oldItem={null} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label htmlFor="">From Name</label>
                                        <input type="text" className="form-control" {...register("from_name")} required />
                                        <span className="text-danger font-size-14">{errors.from_name && errors.from_name.message}</span>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Reply To</label>
                                        <input type="email" className="form-control" {...register("reply_to")} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Email Subject</label>
                                        <input type="text" className="form-control" {...register("email_subject")} required />
                                        <span className="text-danger font-size-14">{errors.email_subject && errors.email_subject.message}</span>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="" className="col-sm-6 col-form-label">Send</label>
                                        <div className="col-md-6">
                                            <select className="form-control" {...register("send")}>
                                                <option value="1" selected={email.send && email.send === "1" ? "selected" : ""}>Social Gallery link</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default Email
